import { Injectable } from "@angular/core";
import { ApiService } from "app/core/http/api.service";
import { buildHttpOptions } from "app/core/http/BuildHttpOptions";
import { Observable } from "rxjs";
import {  SalesYearlySummary, VehicleStockData } from "../mandat-dashboard/mandat-dashboard.service";

export interface AccountingAdminDashboardSummaryResponse {
    yearlySummary: SalesYearlySummary;
    vehicleStock: VehicleStockData;
    completelyPaid: number;
    completelyPaidSum: number;
    partiallyPaid: number;
    partiallyPaidSum: number;
    unpaid: number;
    unpaidSum: number;
    isAbacus: number;
    isAbacusSum: number;
    payments: AccountingAdminPaymentsDto[];
    previousYearPayments: AccountingAdminPaymentsDto[];
}

export interface AccountingAdminPaymentsDto {
    payment: number;
    type: string;
}

export interface VehicleStockDto {
    date: string; // ISO string instead of Date for transport
}

export interface ContractDto {
    revenue: number;
    expense: number;
    date: string; // ISO string
}
@Injectable({ providedIn: 'root' })
export class AccountingAdminDashboardService {

    dashboardUrl = '/dashboard/accounting/';
    constructor(private api: ApiService) { }

    getAccountingAdminDashboardData(paymentYear: number, year: number, VehicleStockPeriod: string): Observable<AccountingAdminDashboardSummaryResponse> {
        const options = buildHttpOptions({
            extraParams: { year: year, paymentsYear: paymentYear, vehicleStockPeriod: VehicleStockPeriod }
        });

        return this.api.get<AccountingAdminDashboardSummaryResponse>(this.dashboardUrl + "summary", options);
    }
}